var styles = {"closeIconAlign":"SearchBox-module_closeIconAlign__sPuIo","searchBoxFilled":"SearchBox-module_searchBoxFilled__gO-XH","readOnly":"SearchBox-module_readOnly__ZPSBz","labeledSearch":"SearchBox-module_labeledSearch__xnVLp"};

export { styles as default };
